import tokenStorageService from "../../../services/TokenStorageService";
import gatewayService from "../../../services/GatewayService";
import * as CONSTANTS from '../../constants';
import {eventTracker} from "../../../services/GoogleAnalyticsService";

/**
 * Retrieves revenue for a given period
 *
 * @param context
 * @param payload
 */
export const getPeriodRevenue = ({ commit, state }, payload) => {
    commit(CONSTANTS.STAT_REVENUE_PERIOD_PENDING);
    const token = tokenStorageService.get();
    return gatewayService.getRevenue(
        state.bookingPeriod.from,
        state.bookingPeriod.to,
        state.arrivalPeriod.from,
        state.arrivalPeriod.to,
        payload,
        token
    ).then((res) => {
        if (res.status === 200) {
            commit(CONSTANTS.STAT_REVENUE_PERIOD_SUCCESS, {
                revenue: res.data.data.totalRevenue,
                bookings: res.data.data.totalBookings,
                sites: res.data.data.sites
            });
        } else {
            commit(CONSTANTS.STAT_REVENUE_PERIOD_NO_CONTENT)
        }
    }).catch(() => {
        commit(CONSTANTS.STAT_REVENUE_PERIOD_FAILURE);
    });
};

/**
 * Retrieves revenue for an entire season
 *
 * @param context
 * @param payload
 */
export const getTotalRevenue = ({ commit, state }, payload) => {
    commit(CONSTANTS.STAT_REVENUE_TOTAL_PENDING);
    const token = tokenStorageService.get();
    return gatewayService.getRevenue(
        state.bookingPeriod.from,
        state.bookingPeriod.to,
        null,
        null,
        payload,
        token
    ).then((res) => {
        if (res.status === 200) {
            commit(CONSTANTS.STAT_REVENUE_TOTAL_SUCCESS, {
                revenue: res.data.data.totalRevenue,
                bookings: res.data.data.totalBookings
            });
        } else {
            commit(CONSTANTS.STAT_REVENUE_TOTAL_NO_CONTENT)
        }
    }).catch(() => {
        commit(CONSTANTS.STAT_REVENUE_TOTAL_FAILURE);
    });
};

/**
 * Updates the current booking period
 *
 * @param context
 * @param rootState
 * @param payload
 */
export const updateBookingPeriod = ({ commit, rootState }, payload) => {
    const user = rootState.auth.user;

    commit(CONSTANTS.STAT_UPDATE_BOOKING_PERIOD, {
        data: payload,
        // Google Analytics
        meta: eventTracker('statistics', 'bookings', 'booking period changed', user.id)
    });
};

/**
 * Updates the current arrival period
 *
 * @param context
 * @param payload
 */
export const updateArrivalPeriod = ({ commit, rootState }, payload) => {
    const user = rootState.auth.user;

    commit(CONSTANTS.STAT_UPDATE_ARRIVAL_PERIOD, {
        data: payload,
        // Google Analytics
        meta: eventTracker('statistics', 'bookings', 'arrival period changed', user.id)
    });
};

/**
 * Updates the currently selected site
 *
 * @param context
 * @param payload
 */
export const updateSelectedSite = ({ commit, rootState }, payload) => {
    const user = rootState.auth.user;

    commit(CONSTANTS.STAT_UPDATE_SELECTED_SITE, {
        data: payload,
        // Google Analytics
        meta: eventTracker('statistics', 'graph', 'user changed site', user.id)
    });
};

/**
 * Updates the currently selected site in the mobile list
 *
 * @param context
 * @param payload
 */
export const updateSelectedStatListItem = ({commit}, payload) => {
    commit(CONSTANTS.STAT_UPDATE_SELECTED_STAT_LIST_ITEM, payload);
};

/**
 * Sets the selected filters
 *
 * @param context
 * @param payload
 */
export const setFilter = ({commit}, payload) => {
    if (payload.hasOwnProperty('sites')) {
        commit(CONSTANTS.STAT_UPDATE_DROPDOWN_SITES, payload.sites);
    } else if (payload.hasOwnProperty('accommodation')) {
        commit(CONSTANTS.STAT_UPDATE_DROPDOWN_ACCOMMODATION, payload.accommodation);
    } else if (payload.hasOwnProperty('list')) {
        commit(CONSTANTS.STAT_UPDATE_DROPDOWN_LIST, payload.list);
    }
};

/**
 * Reset the stats state.
 *
 * @param commit
 */
export const resetState = ({ commit }) => {
    commit(CONSTANTS.STAT_RESET_STATE);
};



// WEBPACK FOOTER //
// ./src/store/modules/stats/actions.js